<template>
    <div class="careerPlanning">
        <!--学科资源-->
        <div class="containers-wrap-21qT_">
            <div>
                <el-tabs v-model="activeName">
                    <el-tab-pane label="生涯视频" name="first">
                        <div class="subject-video-2hQ77">
                            <div class="right-2OM8e" >
                                <div class="lz-tab-filter">
                                    <ul class="lz-tab-filter-content">
                                        <li v-for="(item,index) in careerVideoType"
                                            :key="index"
                                            @click="selectCareerPlanning(item.id)"
                                            :class="careerVideoId===item.id?'active':''"
                                            class="lz-tab-filter-li">
                                            <el-button>
                                                {{item.title}}
                                            </el-button>
                                        </li>
                                    </ul>
                                </div>
                                <div class="lz-tab-filter delFloat" v-show="careerTypeList.length>0">
                                    <ul class="lz-tab-filter-content">
                                        <span class="lz-tab-filter-label">分类：</span>
                                        <li v-for="(item,index) in careerTypeList"
                                            @click="selectCareerSmallPlanning(item.id)"
                                            :class="careerTypeId===item.id?'active':''"
                                            :key="index" class="lz-tab-filter-li">
                                            <el-button>
                                                {{item.title}}
                                            </el-button>
                                        </li>
                                    </ul>
                                </div>
                                <div class="spin-container position-relative">
                                    <div v-show="albumList.length>0&&!albumListLoading">
                                        <div class="summary-2eq9G">共<i>{{totalItem}}</i>个视频</div>
                                        <div class="list-6gZG9">
                                            <div class="comp-group-video-1t4s2 item-2gRzS" v-for="item in albumList" :key="item.albumId">
                                                <div class="info-19Iyl">
                                                    <div class="display-li margin-right">
                                                        <img src="" v-lazy="item.coverImg" :key="item.coverImg" alt="" class="logo-143cK"/>
                                                    </div>
                                                    <div class="detail-2MDwS display-li">
                                                        <div class="title-3YYvN tg-11UAd">
                                                            {{item.name}}
                                                        </div>
                                                        <div class="meta-JP7Sl"><span>主讲老师：</span><span class="val-3E71N">{{item.teacherName}}</span>
                                                        </div>
                                                        <div class="meta-JP7Sl"><span>播放：</span><span class="val-3E71N">{{item.playTimes}}</span>
                                                        </div>
                                                        <!--                                                    <div class="meta-JP7Sl"><span>评分：</span><span-->
                                                        <!--                                                            class="val-3E71N">9.17</span>-->
                                                        <!--                                                    </div>-->
                                                    </div>
                                                    <div class="right-2goiB display-li">
                                                        <div class="a-btn-2ZcKP alignCenter d-flex justifyContentCenter" @click="wholePackage(item,'add')" v-show="!item.hasPackage"><i class="el-icon-plus"></i> 整包加入作业篮</div>
                                                        <div class="a-btn-2ZcKP alignCenter d-flex justifyContentCenter remove" v-show="item.hasPackage" @click="wholePackage(item)"><i class="el-icon-minus"></i> 整包移除作业篮</div>
                                                    </div>
                                                </div>
                                                <div class="list-37wyr" :class="item.hideList||item.videoList.length<=2?'item-1wKlbShow':''">
                                                    <div class="item-1wKlb delFloat" v-for="itemSon in item.videoList" :key="itemSon.videoId">
                                                        <a class="tit-2_HWD" href="javaScript:;">{{itemSon.videoName}}</a>
                                                        <div class="float-right rightBox">
                                                            <div class="add-btn-A2KX6" v-show="!itemSon.hasAdded" @click="aSection(item.albumId,itemSon,'add')"><i class="el-icon-plus"></i> 加入作业篮</div>
                                                            <div class="remove-btn-3N0OC" v-show="itemSon.hasAdded" @click="aSection(item.albumId,itemSon)"><i class="el-icon-minus"></i> 移除作业篮</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-show="item.videoList.length>2&&!item.hideList" class="view-all-2X4I3" @click="hideAlbum(item.albumId,true)"  >查看全部{{item.videoCount}}讲课程</div>
                                                <div v-show="item.videoList.length>2&&item.hideList" class="col-all-1ZjY3"  @click="hideAlbum(item.albumId,false)"  >收起全部{{item.videoCount}}讲课程</div>
                                            </div>
                                        </div>
                                        <el-pagination background
                                                       class="text-right"
                                                       layout="total, prev, pager, next, jumper"
                                                       :page-size="20"
                                                       :total="totalItem"
                                                       :current-page.sync="currentPage"
                                                       @current-change="handlerPage">
                                        </el-pagination>
                                    </div>
                                    <empty v-show="albumList.length<1&&!albumListLoading" content="暂无内容"></empty>
                                    <loading :show="albumListLoading"></loading>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="模拟选科" name="second">
                        <simulated-subject-selection-t></simulated-subject-selection-t>
                    </el-tab-pane>

                </el-tabs>
            </div>
        </div>
    </div>
</template>

<script>
    import {careerVideoList, classOfCareerC, homeworkToBasket, videoResourceDelBasket} from "../../../config";
    import {EventBus} from "../../../assets/static/global/event-bus";
    import simulatedSubjectSelectionT from '../simulatedSubjectSelectionT/simulatedSubjectSelectionT'
    export default {
        name: "careerPlanning",
        components:{
            simulatedSubjectSelectionT
        },
        data() {
            return {
                /******生涯规划相关********/
                albumList:[],
                albumListLoading:false,
                currentPage:1,
                totalItem:0,
                careerVideoType:[],
                careerVideoId:'',
                careerTypeList:[],
                careerTypeId:'',
                activeName: 'first'
            }
        },
        mounted(){
            this.changeContent();
            this.searchCareerPlanning();
        },
        methods:{
            /*******生涯规划相关接口*********/
            //查出生涯课堂的分类
            async searchCareerPlanning(){
                let result=await classOfCareerC();
                if(result.status){
                    this.careerVideoType=result.data;
                    this.careerVideoId=result.data[0].id;
                    this.careerTypeList=result.data[0].children;
                    this.careerTypeId=result.data[0].children[0].id;
                    this.searchCareerList();
                }
            },
            //选择模块大类
            selectCareerPlanning(val){
                this.currentPage=1;
                this.careerVideoId=val;
                let zhi=this.careerVideoType.filter((valsmall)=>{
                    return valsmall.id===val;
                });
                if(zhi[0].children.length>0){
                    this.careerTypeId=zhi[0].children[0].id;
                }else{
                    this.careerTypeId=val;
                }
                this.careerTypeList=zhi[0].children;
                this.searchCareerList();
            },
            //选择小类
            selectCareerSmallPlanning(val){
                this.currentPage=1;
                this.careerTypeId=val;
                this.searchCareerList();
            },
            //查出生涯规划列表
            async searchCareerList(){
                this.albumListLoading=true;
                let result=await careerVideoList(3,'5f0d317b0cd11e1e8ab9ac742b32e33b',this.careerTypeId,this.currentPage,20);
                if(result.status){
                    this.albumListLoading=false;
                    this.albumList= result.data.data;
                    this.totalItem=result.data.totalRecords;
                }else{
                    this.albumListLoading=false;
                }
            },
            //分页相关
            handlerPage(){
                this.searchCareerList();
            },
            //展开全部及收起
            hideAlbum(){
                let zhi=this.albumList.map((valSmall)=>{
                    if(valSmall.albumId===val){
                        valSmall.hideList=flag;
                    }
                    return valSmall;
                })
                this.albumList=zhi;
            },
            //加入作业篮及移出作业篮
            aSection(albumId,itemSon,judge){
                let resources=[
                    {
                        albumId:albumId,
                        title:itemSon.videoName,
                        resourceId:itemSon.videoId,
                        duration:itemSon.duration
                    }
                ];
                if(judge==='add'){
                    this.addVideoBar(resources);
                }else{
                    this.delVideoBar(resources);
                }
            },
            //加入视频篮
            async addVideoBar(item){
                let result=await homeworkToBasket(3,'5f0d317b0cd11e1e8ab9ac742b32e33b',item,2);
                if(result.status){
                    EventBus.$emit('homeworkPick');
                    this.searchCareerList();
                }
            },
            //移出视频篮
            async delVideoBar(item){
                let result=await videoResourceDelBasket(3,'5f0d317b0cd11e1e8ab9ac742b32e33b',item);
                if(result.status){
                    EventBus.$emit('homeworkPick');
                    this.searchCareerList();
                }
            },
            //整包移出及加入作业篮
            wholePackage(item,judge){
                let resources=[];
                for(let i=0;i<item.videoList.length;i++){
                    resources[i]={
                        albumId:item.albumId,
                        title:item.videoList[i].videoName,
                        resourceId:item.videoList[i].videoId,
                        duration:item.videoList[i].duration
                    }
                }
                if(judge==='add'){
                    this.addVideoBar(resources);
                }else{
                    this.delVideoBar(resources);
                }
            },
            changeContent(){
              if(this.$route.query.type){
                  this.activeName=this.$route.query.type;
              }
            },
        }
    }
</script>

<style lang="scss">
    .careerPlanning {
        .el-tabs__item {
            font-size: 16px !important;
            font-feature-settings: 'tnum' !important;
        }

        .el-tabs__nav-wrap {
            height: 60px !important;
        }

        .el-tabs__nav {
            height: 60px !important;
        }

        .el-radio-button__inner {
            padding: 10px !important;
        }
    }
</style>
<style scoped lang="scss">
    .careerPlanning {
        .active{
            .el-button{
                color:#ffffff !important;
            }
            span{
                color:#ffffff !important;
            }
        }
        .containers-wrap-21qT_ {
            position: relative;

            .display-li {
                display: inline-block;
            }

            .lz-tab-filter {
                font-size: 14px;

                overflow: hidden;
                transition: height .3s;

                .lz-tab-filter-label {
                    float: left;
                    color: #7c89a7;
                    line-height: 1;
                    padding: 5px 0;
                    margin-right: 17px;
                }

                .lz-tab-filter-content {
                    float: left;
                    .lz-tab-filter-li {
                        display: inline-block;
                        margin: 0 10px 12px 0;
                        border-radius: 4px;

                        .el-button {
                            display: inline;
                            border: none;
                            background-color: transparent;
                            cursor: pointer;
                            padding: 5px 10px;
                            outline: none;
                            line-height: 1;
                        }
                    }
                }
            }

            .subject-list-7TGNw {
                padding-bottom: 12px;
                border-bottom: 1px solid #f0f0f0;


            }

            .searchBox-1K6el {
                position: absolute;
                right: 0;
                top: 0;

                .res-searcher-2V-5C {
                    display: inline-block;
                    width: 180px;
                    height: 32px;
                    background: #f6f8fc;
                    border-radius: 16px;
                    cursor: pointer;
                    user-select: none;

                    .search-btn-3X0Jc {
                        margin-left: 16px;
                        line-height: 32px;
                        color: #50596f;
                        font-size: 14px;
                    }
                }
            }
            .subject-video-2hQ77 {
                .right-2OM8e {
                    padding: 0 32px 0 24px;
                    margin-left: 0;
                }
            }

            .career-test-1gtvf{
                .list-3oquC{
                    .item-3GM4w {
                        height: 148px;
                        background: #ffffff;
                        border: 1px solid #ededee;
                        border-radius: 4px;
                        box-shadow: 0 0 6px 0 rgba(90,139,255,0.12);
                        padding: 24px 24px 21px;
                        margin-bottom: 25px;
                        .pic-3UtH8 {
                            width: 182px;
                            height: 103px;
                            float: left;
                        }
                        .center-3GGCk {

                            margin: 0 150px 0 205px;
                            .tit-2mQH_ {
                                font-size: 16px;
                                color: #50596f;
                                line-height: 16px;
                                cursor: pointer;
                            }
                            .desc-1Tv4q {
                                margin-top: 15px;
                                font-size: 12px;
                                color: #96a2be;
                                line-height: 15px;
                                display: -webkit-box;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                -webkit-line-clamp: 4;
                                -webkit-box-orient: vertical;
                            }
                        }
                        .btn-1eCBj {
                            float: right;
                            align-self: center;
                            height: 32px;
                            width: 88px;
                            line-height: 32px;
                            text-align: center;
                            background: #5a8bff;
                            border-radius: 4px;
                            color: white;
                            font-size: 14px;
                            cursor: pointer;
                            user-select: none;
                        }
                    }
                }
            }

        }
    }

</style>
